import('./bootstrap')
  .then(({ bootstrapApp }) => bootstrapApp())
  .catch((err: unknown) => {
    console.error('Failed to bootstrap the app:', err);
  });
